import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

export default function WhatsAppWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState("");
  
  const phoneNumber = "917618759333"; // Replace with your WhatsApp number (with country code, no '+')
  const welcomeMessage = "Hi! I'm interested in your preschool programs. Can you please share more information?";

  useEffect(() => {
    // Show widget after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleSendMessage = () => {
    const text = message || welcomeMessage;
    const encodedMessage = encodeURIComponent(text);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
    setIsOpen(false);
    setMessage("");
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* WhatsApp Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all duration-300 transform hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        {isOpen ? (
          <X size={28} className="animate-in fade-in" />
        ) : (
          <MessageCircle size={28} className="animate-in fade-in" />
        )}
      </button>

      {/* Chat Popup */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          {/* Header */}
          <div className="bg-green-500 px-4 py-3 flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <MessageCircle size={20} className="text-green-500" />
            </div>
            <div>
              <h3 className="text-white font-semibold text-sm">WhatsApp Chat</h3>
              <p className="text-green-100 text-xs">Typically replies within minutes</p>
            </div>
          </div>

          {/* Message Area */}
          <div className="p-4">
            <div className="mb-4">
              <div className="bg-gray-100 rounded-2xl p-3 max-w-[90%]">
                <p className="text-sm text-gray-800">
                  👋 Hi there! Welcome to Seekers Bay Preschool. How can we help you today?
                </p>
              </div>
            </div>
            
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message here..."
              className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-400 resize-none"
              rows="3"
            />
            
            <button
              onClick={handleSendMessage}
              className="w-full mt-3 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded-xl transition-colors"
            >
              Send Message
            </button>
            
            <p className="text-xs text-gray-400 text-center mt-3">
              We'll respond quickly on WhatsApp
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
